import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15dc6f5a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main_task" }
const _hoisted_2 = { class: "list_search" }
const _hoisted_3 = { class: "search_header" }
const _hoisted_4 = {
  class: "flexWrap",
  style: {"width":"80%"}
}
const _hoisted_5 = { class: "header_nr flexAlign" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nr_left",
  style: {"width":"82px"}
}, "部门：", -1))
const _hoisted_7 = { class: "header_nr flexAlign" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nr_left",
  style: {"width":"100px"}
}, "创建开始时间：", -1))
const _hoisted_9 = { class: "header_nr flexAlign" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nr_left",
  style: {"width":"100px"}
}, "创建截止时间：", -1))
const _hoisted_11 = { class: "header_nr flexAlign" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "nr_left",
  style: {"width":"82px"}
}, "事项类型：", -1))
const _hoisted_13 = {
  class: "header_nr flexAlign",
  style: {"margin-left":"20px"}
}
const _hoisted_14 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("导出excel")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1))
const _hoisted_17 = { class: "normal" }
const _hoisted_18 = {
  class: "flexEnd",
  style: {"padding":"20px"}
}
const _hoisted_19 = { class: "qp" }
const _hoisted_20 = { class: "my-header" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "任务详情", -1))

import { CirclePlus, Search } from '@element-plus/icons-vue';
	import { onMounted, ref, nextTick } from 'vue';
	import { requestDDDepartlist } from '@/api/xmApi';
	import { requestGetAllConfig } from '@/api/configApi.js';
	import { requestTaskQueryList } from '@/api/api';
	import TaskDetails from '@/components/TaskDetails.vue';

	
export default /*#__PURE__*/_defineComponent({
  name: 'TaskQuery',
  setup(__props) {

	const list = ref<any[]>([])
	const loading = ref<boolean>(false)
	const pageIndex = ref<number>(1)
	const pageSize = ref<number>(20)
	const pages = ref({
		totalCount: 0
	})
	const dddepartid = ref("")
	const DDDepartlist = ref<any[]>([])
	const sxlxLists = ref<any[]>([])
	const search = ref({
		createtime1: '',
		createtime2: '',
		sxlx: ''
	})
	const taskDetails = ref(false)
	const taskDetailsShow = ref(false)
	const form = ref<any>({})

	onMounted(() => {
		getDDDepartlist();
		getSxlxList();
		getTaskList();
	})

	const getSxlxList = () => {
		requestGetAllConfig({type:'事项类型'}).then((res:any)=>{
			if(res.status === 1){
				sxlxLists.value = res.datalist
			}
		})
	}

	const getDDDepartlist = () => {
		requestDDDepartlist({}).then((res: any) => {
			DDDepartlist.value = res.datalist;
		})
	}

	const getTaskList = () => {
		loading.value = true
		requestTaskQueryList({
			dddepartid: dddepartid.value,
			pageIndex: pageIndex.value,
			pageSize: pageSize.value,
			createtime1: search.value.createtime1,
			createtime2: search.value.createtime2,
			sxlx: search.value.sxlx
		}).then((res: any) => {
			list.value = res.data
			pages.value.totalCount = res.totalCount
			loading.value = false
		})
	}

	const searchList = () => {
		pageIndex.value = 1
		getTaskList();
	}

	const handleSizeChange = (val: number) => {
		pageSize.value = val
		getTaskList();
	}
	const handleCurrentChange = (val: number) => {
		pageIndex.value = val
		getTaskList();
	}

	const details = (row: any) => {
		form.value = row.cell
		taskDetailsShow.value = false
		nextTick(() => {
			taskDetailsShow.value = true
		})
		taskDetails.value = true
	}

	const cancelDetails = () => {
		taskDetails.value = false
		getTaskList()
	}

	const taskListsx = () => {
		getTaskList()
		taskDetails.value = false
	}

	const DCsearchList = () => {
		requestTaskQueryList({
			dddepartid: dddepartid.value,
			pageIndex: 1,
			pageSize: 99999,
			createtime1: search.value.createtime1,
			createtime2: search.value.createtime2,
			sxlx: search.value.sxlx,
			dc: 1
		}).then((res: any) => {
			window.open(res.datalist)
		})
	}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode(_component_el_select, {
              size: "small",
              filterable: "",
              modelValue: dddepartid.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dddepartid).value = $event)),
              placeholder: "请选择",
              style: {"width":"150px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(DDDepartlist.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: `${item.name}(${item.c})`,
                    value: `${item.dept_id}`,
                    key: index
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_el_date_picker, {
              modelValue: search.value.createtime1,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search.value.createtime1) = $event)),
              type: "date",
              placeholder: "开始时间",
              "value-format": "YYYY-MM-DD"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_el_date_picker, {
              modelValue: search.value.createtime2,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((search.value.createtime2) = $event)),
              type: "date",
              placeholder: "截止时间",
              "value-format": "YYYY-MM-DD"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_el_select, {
              modelValue: search.value.sxlx,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((search.value.sxlx) = $event)),
              size: "small",
              placeholder: "请选择",
              style: {"width":"120px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_option, {
                  label: "全部",
                  value: ""
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sxlxLists.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.value,
                    value: item.value,
                    key: index
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_el_button, {
              plain: "",
              type: "primary",
              size: "small",
              icon: _unref(Search),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (searchList()))
            }, {
              default: _withCtx(() => [
                _hoisted_14
              ]),
              _: 1
            }, 8, ["icon"]),
            _createVNode(_component_el_button, {
              plain: "",
              type: "primary",
              size: "small",
              icon: _unref(Search),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (DCsearchList()))
            }, {
              default: _withCtx(() => [
                _hoisted_15
              ]),
              _: 1
            }, 8, ["icon"])
          ])
        ])
      ])
    ]),
    _hoisted_16,
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      onCellClick: details,
      data: list.value,
      "header-cell-style": {color:'#000',backgroundColor:'#fafbfd'}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          width: "80",
          label: "序号",
          align: "center"
        }),
        _createVNode(_component_el_table_column, {
          label: "事项类型",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", null, _toDisplayString(scope.row.cell.type1), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "执行人",
          width: "100"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", null, _toDisplayString(scope.row.cell.operatorname), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "创建日期",
          width: "160"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", null, _toDisplayString(scope.row.cell.createtime), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "任务标题",
          "min-width": "200"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_17, _toDisplayString(scope.row.cell.tasktitle), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "总进度",
          width: "100",
          align: "center"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", null, _toDisplayString(scope.row.cell.nowjl) + "/" + _toDisplayString(scope.row.cell.maxjl), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "首条日志时间",
          width: "160"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", null, _toDisplayString(scope.row.cell.firstlogtime), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "最后日志时间",
          width: "160"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", null, _toDisplayString(scope.row.cell.lastlogtime), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "备注",
          width: "200"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", null, _toDisplayString(scope.row.cell.remarks), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data"])), [
      [_directive_loading, loading.value]
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        currentPage: pageIndex.value,
        "onUpdate:currentPage": _cache[6] || (_cache[6] = ($event: any) => ((pageIndex).value = $event)),
        "page-sizes": [10, 20, 30, 50],
        "page-size": pageSize.value,
        "onUpdate:page-size": _cache[7] || (_cache[7] = ($event: any) => ((pageSize).value = $event)),
        layout: "total, sizes, prev, pager, next, jumper",
        total: pages.value.totalCount
      }, null, 8, ["currentPage", "page-size", "total"])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createVNode(_component_el_dialog, {
        modelValue: taskDetails.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((taskDetails).value = $event)),
        "show-close": false,
        fullscreen: ""
      }, {
        header: _withCtx(({ close, titleId, titleClass }) => [
          _createElementVNode("div", _hoisted_20, [
            _hoisted_21,
            _createVNode(_component_el_icon, {
              class: "delicon",
              onClick: _cache[8] || (_cache[8] = ($event: any) => (cancelDetails()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Close)
              ]),
              _: 1
            })
          ])
        ]),
        default: _withCtx(() => [
          (taskDetailsShow.value)
            ? (_openBlock(), _createBlock(TaskDetails, {
                key: 0,
                form: form.value,
                onTaskListsx: taskListsx
              }, null, 8, ["form"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ]))
}
}

})